// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h3[data-v-4a9c7364],p[data-v-4a9c7364]{text-align:center}p[data-v-4a9c7364]{color:var(--base-medium-color);font-size:.7rem;margin-top:1rem;display:block;clear:both;margin-bottom:2rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
